import template   from './home-slider.html'
import controller from './home-slider.controller'

import './home-slider.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/home/slider/home-slider.component.js